export function formatDurationDH(duration?: number | string | null, keepMs = true): string {
  if (duration == null || duration === '') return '';

  const parseMs = (val: number | string): number | null => {
    if (typeof val === 'number' && Number.isFinite(val)) return Math.max(0, Math.floor(val));

    if (typeof val === 'string') {
      const trimmed = val.trim();

      if (/^\d+$/.test(trimmed)) return Math.max(0, Math.floor(Number(trimmed)));

      const legacy = /^(?:(\d+)\s*day(?:s)?\s*,?\s*)?(\d+):([0-5]\d):([0-5]\d)(?:\.(\d+))?$/i.exec(trimmed);
      if (legacy) {
        const days = parseInt(legacy[1] ?? '0', 10);
        const hours = parseInt(legacy[2], 10);
        const minutes = parseInt(legacy[3], 10);
        const seconds = parseInt(legacy[4], 10);
        const millis = legacy[5] ? parseInt(legacy[5].padEnd(3, '0').slice(0, 3), 10) : 0;
        const totalMs = (((days * 24 + hours) * 60 + minutes) * 60 + seconds) * 1000 + millis;
        return Math.max(0, totalMs);
      }
    }

    return null;
  };

  const ms = parseMs(duration);
  if (ms == null) return String(duration);

  const totalSeconds = Math.floor(ms / 1000);

  const days = Math.floor(totalSeconds / 86400);
  const remAfterDays = totalSeconds % 86400;

  const hours = Math.floor(remAfterDays / 3600);
  const minutes = Math.floor((remAfterDays % 3600) / 60);
  const seconds = remAfterDays % 60;

  const pad2 = (n: number) => String(n).padStart(2, '0');

  if (days > 0) {
    return keepMs ? `${days}d ${hours}:${pad2(minutes)}:${pad2(seconds)}` : `${days}d ${hours}h`;
  }

  return `${pad2(hours)}:${pad2(minutes)}:${pad2(seconds)}`;
}
